import React from "react";
import { useTranslation } from "react-i18next";
import { Box } from "@mui/material";
import { useMyHrUserRolesDataByContract } from "my-hr/hooks";
import { OcCard, OcRoleFilter } from "oc/components";
import { ProductsT, RoleCategoriesT } from "oc/configs/constants";
import { useOcIsMobile } from "oc/hooks";

interface Contract {
  code?: string;
  company?: {
    name?: string;
  };
  jobClass?: {
    name?: string;
  };
}

export const MyHrProfilesRolesData: React.FC<{ contract: Contract }> = ({
  contract,
}) => {
  const { t } = useTranslation();
  const isMobile = useOcIsMobile();

  const { data: rolesData, loading } = useMyHrUserRolesDataByContract({
    contract: contract?.code ?? "",
  });

  let jobClassName = contract?.jobClass?.name
    ? contract.jobClass.name.charAt(0).toUpperCase() +
      contract.jobClass.name.slice(1)
    : "";

  return (
    <OcCard
      label={`${jobClassName} - ${contract?.company?.name} (${
        contract?.code
      }) - ${t("MY_HR_ROLES")}`}
      loading={loading}
    >
      <Box display="flex" flexDirection="column" alignItems="center">
        {rolesData.map((role) => {
          return (
            <Box
              width={isMobile ? "100%" : "728px"}
              paddingBottom="16px"
              key={role.id}
            >
              <OcRoleFilter
                subtypeProps={{
                  product: role.product as ProductsT,
                  role: role.role as RoleCategoriesT,
                  roleFilters: role.roleFilters,
                  queryType: "notAdmin",
                  editable: false,
                  handleAddItem: () => {},
                  handleRemoveItem: () => {},
                }}
                innerWidth="100%"
                chipData={{
                  role: role.role,
                  product: role.product,
                }}
                noCollapse={role.role === "user" || role.role === "admin"}
              />
            </Box>
          );
        })}
      </Box>
    </OcCard>
  );
};

export default MyHrProfilesRolesData;
